import React from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';
import Dynamicmeta from "./Dynamicmeta";

const EmailAccountGuide = () => {
  return (
    <>
    <Dynamicmeta/>
    <Header />
    <div className="full-div" id="blog">
      <Container fluid className="main-sec">
        <Row>
          <Col sm={2}></Col>
          <Col sm={7} className="bg-white p-4 div-shadow mb-3">
            <h1 className="head-color">How to Create an Email Account in cPanel | Step-by-Step Guide</h1>
            <span className="small ms-2">
              <b>Publish By:-</b> CodeInputs
            </span>

            <Row className="mt-3 text-center">
              <Col md={12}>
                <Image
                  src="/graphics/images/Email_accounts.png"
                  alt="Email Account in cPanel"
                  fluid
                />
              </Col>
            </Row>

            <p className="mt-4 blacktext">
              Managing email accounts through cPanel is an essential skill for website owners and businesses. cPanel provides a user-friendly interface that allows you to create and manage professional email accounts associated with your domain. This guide will walk you through the steps to create an email account in cPanel.
            </p>

            <h2>Step-by-Step Guide to Creating an Email Account</h2>
            
            <h3>Step 1: Log in to cPanel</h3>
            <ol>
              <li>Go to your cPanel login page: <code>https://yourdomain.com/cpanel</code> or <code>https://yourserverIP:2083</code></li>
              <li>Enter your <strong>username</strong> and <strong>password</strong>, then click <strong>Log In</strong>.</li>
            </ol>

            <h3>Step 2: Navigate to Email Accounts</h3>
            <ol>
              <li>Scroll down to the <strong>Email</strong> section in cPanel.</li>
              <li>Click on <strong>Email Accounts</strong>.</li>
            </ol>

            <h3>Step 3: Create a New Email Account</h3>
            <ol>
              <li>Click on the <strong>+ Create</strong> button.</li>
              <li>Choose the <strong>domain</strong> from the dropdown list.</li>
              <li>Enter the <strong>Username</strong> (e.g., info, support, yourname).</li>
              <li>Set a <strong>strong password</strong> or use the <strong>Generate Password</strong> option.</li>
              <li>Select the <strong>Storage Space</strong> for the email account.</li>
              <li>Click <strong>Create</strong> to finalize the setup.</li>
            </ol>

            <h3>Step 4: Access Your Email Account</h3>
            <ol>
              <li>Return to the <strong>Email Accounts</strong> page.</li>
              <li>Find your account and click <strong>Check Email</strong>.</li>
              <li>Select a webmail client (Roundcube, Horde, or SquirrelMail).</li>
            </ol>

            <h3>Step 5: Configure Email on Devices</h3>
            <p className="mt-4 blacktext">You can set up your email on apps like Outlook or Gmail.</p>
            <ul>
              <li>Go to <strong>Email Accounts</strong> &gt; <strong>Connect Devices</strong>.</li>
              <li>Follow the provided IMAP/POP3 and SMTP settings.</li>
            </ul>

            <h2>Conclusion</h2>
            <p className="mt-4 blacktext">
              Creating an email account in cPanel is quick and easy. It allows you to have a professional email address linked to your domain, improving your brand's credibility. With the steps outlined above, you can efficiently manage business or personal emails through cPanel.
            </p>
          </Col>
          
          <Col sm={3} className="recent-post">
            <Card className="bg-white p-4 mb-3 div-shadow">
              <h4 className="head-color">Recent Post</h4>
              <RecentPost />
              
            </Card>

            <Card className="bg-white p-4 div-shadow">
              <h4 className="mt-4 head-color">Recent Comment</h4>
              <p style={{ color: "#85929e" }}>No Comments to Show</p>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    <Footer />
    </>
  );
};

export default EmailAccountGuide;
